import { ReactComponent as Arrow } from "assets/images/icons/arrow.svg";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./Back.module.scss";

interface Props {
  className?: string;
}

export const Back = ({ className }: Props) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(-1);
  };

  return (
    <div className={cn(styles.root, className)} onClick={handleClick}>
      <Arrow />
      Back
    </div>
  );
};
